import { render } from "./InfoCard.vue?vue&type=template&id=697589ff"
import script from "./InfoCard?vue&type=script&lang=js"
export * from "./InfoCard?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__